import { useEffect } from 'react';
import Konva from 'konva';

type KonvaDragHandlers = {
  _drag: (event: Event) => void;
  _endDragBefore: (event?: Event) => void;
  _endDragAfter: (event?: Event) => void;
};

// Konva's drag&drop module registers its move/up listeners on the main window
// only. A drag started inside another window (the canvas PiP window) never
// receives them there: the drag is never ended and the node starts chasing the
// pointer with foreign coordinates once it re-enters the main window. Mirrors
// Konva's global DD listeners on the given window (same set and phases as
// Konva.Global registers on the main one).
export const useKonvaDragWindowBinding = (
  targetWindow: Window | null
): void => {
  useEffect(() => {
    if (!targetWindow) {
      return;
    }

    const dragAndDrop = (Konva as unknown as { DD: KonvaDragHandlers }).DD;

    targetWindow.addEventListener('mouseup', dragAndDrop._endDragBefore, true);
    targetWindow.addEventListener('touchend', dragAndDrop._endDragBefore, true);
    targetWindow.addEventListener('mousemove', dragAndDrop._drag);
    targetWindow.addEventListener('touchmove', dragAndDrop._drag);
    targetWindow.addEventListener('mouseup', dragAndDrop._endDragAfter, false);
    targetWindow.addEventListener('touchend', dragAndDrop._endDragAfter, false);

    return () => {
      targetWindow.removeEventListener(
        'mouseup',
        dragAndDrop._endDragBefore,
        true
      );
      targetWindow.removeEventListener(
        'touchend',
        dragAndDrop._endDragBefore,
        true
      );
      targetWindow.removeEventListener('mousemove', dragAndDrop._drag);
      targetWindow.removeEventListener('touchmove', dragAndDrop._drag);
      targetWindow.removeEventListener(
        'mouseup',
        dragAndDrop._endDragAfter,
        false
      );
      targetWindow.removeEventListener(
        'touchend',
        dragAndDrop._endDragAfter,
        false
      );
    };
  }, [targetWindow]);
};
